module.exports = __webpack_public_path__ + "static/media/patched.b63cb8b0.svg";